import { render, staticRenderFns } from "./AggregationList.vue?vue&type=template&id=4af404ff&scoped=true"
import script from "./AggregationList.vue?vue&type=script&lang=js"
export * from "./AggregationList.vue?vue&type=script&lang=js"
import style0 from "./AggregationList.vue?vue&type=style&index=0&id=4af404ff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af404ff",
  null
  
)

export default component.exports